import React from 'react';
import ResponsiveListbox from 'components/Form/ResponsiveListbox';
import { propTypes } from './DriversAgePropTypes';

const DriversAge = React.memo(({ label, options, setAge, readOnly, tooltip, driversAge, isDriverAgeUpdated }) => (
  <ResponsiveListbox
    id={'driversAge'}
    name={'driversAge'}
    className='fill'
    onChange={setAge}
    label={label}
    options={options}
    required
    readOnly={readOnly}
    tooltip={tooltip}
    useMobileVersionForTablet
    driversAge={driversAge}
    isDriverAgeUpdated={isDriverAgeUpdated}
  />
));

DriversAge.propTypes = propTypes;

export default DriversAge;
